import { Vue } from 'vue-property-decorator';
import APP_CONST from './AppConst';

export default class MANAGE_FAMILY_CONST extends Vue {

  public static readonly GradesList = [{id:'Pre-K',value:'Pre-K'},{id:'K',value:'K'},{id:'1',value:'1'},{id:'2',value:'2'},{id:'3',value:'3'},{id:'4',value:'4'},{id:'5',value:'5'},{id:'6',value:'6'},{id:'7',value:'7'},{id:'8',value:'8'},{id:'9',value:'9'},{id:'10',value:'10'},{id:'11',value:'11'},{id:'12',value:'12'}];
  public static readonly CallOrdersList = [0,1,2,3,4,5];
  public static readonly PhoneTypes= [{ id: 'Cell', value: 'Cell' }, { id: 'Work', value: 'Work' }, { id: 'Home', value: 'Home' }];
  public static readonly PlansValue = ['Bus', 'Car', 'Walk', 'Public Transportation'];
  public static readonly INPUTTYPES = ['firstName', 'lastName', 'phone', 'phoneNumber'];
    
  public static readonly ScholarInfoHeader = [
    {
      name: 'First Name',
      key: 'firstName',
    },
    {
      name: 'Last Name',
      key: 'lastName'
    },
    {
      name: 'Nickname',
      key: 'nickName'
    },
    {
      name: 'Birth Date',
      key: 'birthDate'
    },
    {
      name: 'Age',
      key: 'age'
    },
    {
      name: 'Grade',
      key: 'grade'
    },
    {
      name: 'T-Shirt Size',
      key: 'tShirtSize'
    },
    {
      name: 'Gender',
      key: 'gender'
    },
    {
      name: 'Race/Ethnicity',
      key: 'ethnicity'
    },
    {
      name: 'Email',
      key: 'email'
    },
    {
      name: 'Phone',
      key: 'phone'
    },
    {
      name: 'Phone Type',
      key: 'phoneType'
    },
    {
      name: 'Address',
      key: 'address'
    },
    {
      name: 'School Name',
      key: 'schoolName'
    },
    {
      name: 'Scholar Student ID',
      key: 'schoolStudentId'
    },
    {
      name: 'Language at Home',
      key: 'homeLanguage'
    },
    {
      name: 'Allergies',
      key: 'allergies'
    },
    {
      name: 'EPI Pen',
      key: 'epiPen'
    },
    {
      name: 'Asthma Inhaler',
      key: 'asthmaInhaler'
    },
    {
      name: 'Medication',
      key: 'medication'
    },
    {
      name: 'Insurance Provider',
      key: 'insuranceProvider'
    },
    {
      name: 'IEP',
      key: 'iep'
    },
    {
      name: 'ELL/LEP',
      key: 'llp'
    },
    {
      name: 'Special Education Status',
      key: 'specialEducation'
    }
  ];

  public static readonly EnrollmentStatusHeader = [
    {
      name: 'First Name',
      key: 'firstName',
    },
    {
      name: 'Last Name',
      key: 'lastName'
    },
    {
      name: 'Relationship to Child',
      key: 'relation'
    },
    {
      name: 'Email',
      key: 'email'
    },
    {
      name: 'Phone Number',
      key: 'phone'
    },
    {
      name: 'Phone Type',
      key: 'phoneType'
    },
    {
      name: 'Secondary Phone',
      key: 'secondaryPhone'
    },
    {
      name: 'Secondary Phone Type',
      key: 'secondaryPhoneType'
    },
    {
      name: 'Address',
      key: 'address'
    },
    {
      name: 'Languages at Home',
      key: 'homeLanguage'
    }
  ];

  public static readonly EmargencyContactHeader = [
    {
      name: 'Call Order',
      key: 'callOrder',
    },
    {
      name: 'First Name',
      key: 'firstName',
    },
    {
      name: 'Last Name',
      key: 'lastName'
    },
    {
      name: 'Relationship to Child',
      key: 'relation'
    },
    {
      name: 'Phone',
      key: 'phone'
    },
    {
      name: 'Phone Type',
      key: 'phoneType'
    }
  ];

  public static readonly AuthorizedPickUp = [
    {
      name: 'First Name',
      key: 'firstName',
    },
    {
      name: 'Last Name',
      key: 'lastName',
    },
    {
      name: 'Relationship to Child',
      key: 'relation',
    },
    {
      name: 'Phone Number',
      key: 'phone',
    },
    {
      name: 'Phone Type',
      key: 'phoneType',
    },
    {
      name: 'Effective From',
      key: 'pickUpStartDate',
    },
    {
      name: 'To',
      key: 'pickUpEndDate',
    },
  ];

  public static EditGuardianDetails = [
    {
      textValue: 'Guardian(s)',
      primaryGuardian: {
        name: 'Mark as Primary Guardian',
        value: false,
        errorStatus: false,
        errorText: ''
      },
      callOrder: {
        name: 'Call Order',
        value: '',
        errorStatus: false,
        errorText: '',
        dropStatus: false,
      },
      firstName: {
        name: 'First Name',
        value: '',
        errorStatus: false,
        errorText: 'This field is required. (Es necesario llenar este espacio.)',
        error: false,
        alphaCharError: false,
        errorAlpha: 'Use only letters, hyphens, and apostrophes in the name field. Other special characters, including accents, are not supported. (Por ahora, en el campo de nombre usa solo letras, guiones y apóstrofes. No se admiten otros caracteres especiales, incluidas las tildes, las eñes (ñ), etc.)',
        minimumCharError: false,
        errorMinimumLength: 'Maximum 50 characters allowed',
        duplicateErrorStatus: false,
        duplicateErrorMessage: 'It looks like we already have details for this contact. Try adding a different contact, instead!'
      },
      lastName: {
        name: 'Last Name',
        value: '',
        errorStatus: false,
        errorText: 'This field is required. (Es necesario llenar este espacio.)',
        error: false,
        alphaCharError: false,
        errorAlpha: 'Use only letters, hyphens, and apostrophes in the name field. Other special characters, including accents, are not supported. (Por ahora, en el campo de nombre usa solo letras, guiones y apóstrofes. No se admiten otros caracteres especiales, incluidas las tildes, las eñes (ñ), etc.)',
        minimumCharError: false,
        errorMinimumLength: 'Maximum 50 characters allowed',
        duplicateErrorStatus: false,
        duplicateErrorMessage: 'It looks like we already have details for this contact. Try adding a different contact, instead!'
      },
      relation: {
        name: 'Relationship to Child',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      email: {
        name: 'Email',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      phone: {
        name: 'Phone',
        value: '',
        errorStatus: false,
        errorText: 'This field is required. (Es necesario llenar este espacio.)'
      },
      phoneType: {
        name: 'Phone Type',
        value: '',
        errorStatus: false,
        errorText: '',
        dropStatus: false
      },
      secondaryPhone: {
        name: 'Secondary Phone Number',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      secondaryPhoneType: {
        name: 'Secondary Phone Type',
        value: '',
        errorStatus: false,
        errorText: '',
        dropStatus: false
      },
      address1: {
        name: 'Address Line 1',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      address2: {
        name: 'Address Line 2',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      city: {
        name: 'City',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      state: {
        name: 'State',
        value: '',
        errorStatus: false,
        errorText: '',
        dropStatus: false
      },
      zip: {
        name: 'Zip Code',
        value: '',
        errorStatus: false,
        errorText: 'Be sure to enter all 5 digits. (Escribe los 5 números.)'
      },
      homeLanguage: {
        name: 'Language at Home',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      status: {
        name: 'Status',
        value: APP_CONST.ONE
      },
      guid: {
        name:'Guid',
        value: null
      }
    }
  ];

  public static EditEmergencyDetails = [
    {
      textValue: 'Emergency Contact(s)',
      callOrder: {
        name: 'Call Order',
        value: '',
        dropStatus: false,
        errorStatus: false,
        errorText: '',
        listValues: []
      },
      firstName: {
        name: 'First Name',
        value: '',
        errorStatus: false,
        requiredStatus: false,
        errorText: 'This field is required. (Es necesario llenar este espacio.)',
        error: false,
        alphaCharError: false,
        errorAlpha: 'Use only letters, hyphens, and apostrophes in the name field. Other special characters, including accents, are not supported. (Por ahora, en el campo de nombre usa solo letras, guiones y apóstrofes. No se admiten otros caracteres especiales, incluidas las tildes, las eñes (ñ), etc.)',
        minimumCharError: false,
        errorMinimumLength: 'Maximum 50 characters allowed',
        duplicateErrorStatus: false,
        duplicateErrorMessage: 'It looks like we already have details for this contact. Try adding a different contact, instead!'
      },
      lastName: {
        name: 'Last Name',
        value: '',
        errorStatus: false,
        requiredStatus: false,
        errorText: 'This field is required. (Es necesario llenar este espacio.)',
        error: false,
        alphaCharError: false,
        errorAlpha: 'Use only letters, hyphens, and apostrophes in the name field. Other special characters, including accents, are not supported. (Por ahora, en el campo de nombre usa solo letras, guiones y apóstrofes. No se admiten otros caracteres especiales, incluidas las tildes, las eñes (ñ), etc.)',
        minimumCharError: false,
        errorMinimumLength: 'Maximum 50 characters allowed',
        duplicateErrorStatus: false,
        duplicateErrorMessage: 'It looks like we already have details for this contact. Try adding a different contact, instead!'
      },
      relation: {
        name: 'Relationship to Child',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      phone: {
        name: 'Phone',
        value: '',
        errorStatus: false,
        requiredStatus: false,
        errorText: 'This field is required. (Es necesario llenar este espacio.)'
      },
      phoneType: {
        name: 'Phone Type',
        value: '',
        errorStatus: false,
        requiredStatus: false,
        errorText: 'Phone Type is required',
        dropStatus: false
      },
      status: {
        name: 'Status',
        value: ''
      },
      disableDelete:{
        name:'Disable Delete',
        value:false
      }
    }
  ];

  public static EditScholarDetails = [
    {
      textValue: 'Child Information',
      firstName: {
        name: 'First Name',
        value: '',
        errorStatus: false,
        requiredStatus: false,
        errorText: 'This field is required. (Es necesario llenar este espacio.)',
        error: false,
        alphaCharError: false,
        errorAlpha: 'Use only letters, hyphens, and apostrophes in the name field. Other special characters, including accents, are not supported. (Por ahora, en el campo de nombre usa solo letras, guiones y apóstrofes. No se admiten otros caracteres especiales, incluidas las tildes, las eñes (ñ), etc.)',
        minimumCharError: false,
        errorMinimumLength: 'Maximum 50 characters allowed'
      },
      lastName: {
        name: 'Last Name',
        value: '',
        errorStatus: false,
        requiredStatus: false,
        errorText: 'This field is required. (Es necesario llenar este espacio.)',
        error: false,
        alphaCharError: false,
        errorAlpha: 'Use only letters, hyphens, and apostrophes in the name field. Other special characters, including accents, are not supported. (Por ahora, en el campo de nombre usa solo letras, guiones y apóstrofes. No se admiten otros caracteres especiales, incluidas las tildes, las eñes (ñ), etc.)',
        minimumCharError: false,
        errorMinimumLength: 'Maximum 50 characters allowed'
      },
      nickName: {
        name: 'Nickname',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      birthDate: {
        name: 'Birth Date',
        value: '',
        errorStatus: false,
        errorText: 'Be sure to enter MM-DD-YYYY. (Asegúrate de escribir la fecha de nacimiento (mes, día, año) MM-DD-AAAA)'
      },
      age: {
        name: 'Age',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      grade: {
        name: 'Grade',
        value: '',
        dropStatus: false,
        errorStatus: false,
        errorText: ''
      },
      tShirtSize: {
        name: 'T-Shirt Size',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      gender: {
        name: 'Gender',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      email: {
        name: 'Email',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      phone: {
        name: 'Phone',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      phoneType: {
        name: 'Phone Type',
        value: '',
        errorStatus: false,
        errorText: '',
        dropStatus: false
      },
      address1: {
        name: 'Address Line 1',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      address2: {
        name: 'Address Line 2',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      city: {
        name: 'City',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      state: {
        name: 'State',
        value: '',
        errorStatus: false,
        errorText: '',
        dropStatus: false
      },
      zip: {
        name: 'Zip Code',
        value: '',
        errorStatus: false,
        errorText: 'Be sure to enter all 5 digits. (Escribe los 5 números.)'
      },
      schoolName: {
        name: 'School Name',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      schoolStudentId: {
        name: 'Scholar Student ID',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      homeLanguage: {
        name: 'Language at Home',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      ethnicity: {
        name: 'Race/Ethnicity',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      allergies: {
        name: 'Allergies',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      epiPen: {
        name: 'EPI Pen',
        value: '',
        errorStatus: false,
        errorText: '',
        dropStatus: false
      },
      asthmaInhaler: {
        name: 'Asthma Inhaler',
        value: '',
        errorStatus: false,
        errorText: '',
        dropStatus: false
      },
      medication: {
        name: 'Medication',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      insuranceProvider: {
        name: 'Insurance Provider',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      iep: {
        name: 'IEP',
        value: '',
        errorStatus: false,
        errorText: '',
        dropStatus: false
      },
      llp: {
        name: 'ELL/LEP',
        value: '',
        errorStatus: false,
        errorText: '',
        dropStatus: false
      },
      specialEducation: {
        name: 'Special Education Status',
        value: '',
        errorStatus: false,
        errorText: ''
      }
    }
  ];

  public static EditAuthorizePickUp = [
    {
      textValue: 'Authorized Pickup(s)',
      firstName: {
        name: 'First Name',
        value: '',
        errorStatus: false,
        requiredStatus: false,
        errorText: 'This field is required. (Es necesario llenar este espacio.)',
        error: false,
        alphaCharError: false,
        errorAlpha: 'Use only letters, hyphens, and apostrophes in the name field. Other special characters, including accents, are not supported. (Por ahora, en el campo de nombre usa solo letras, guiones y apóstrofes. No se admiten otros caracteres especiales, incluidas las tildes, las eñes (ñ), etc.)',
        minimumCharError: false,
        errorMinimumLength: 'Maximum 50 characters allowed',
        duplicateErrorStatus: false,
        duplicateErrorMessage: 'It looks like we already have details for this contact. Try adding a different contact, instead!'
      },
      lastName: {
        name: 'Last Name',
        value: '',
        errorStatus: false,
        requiredStatus: false,
        errorText: 'This field is required. (Es necesario llenar este espacio.)',
        error: false,
        alphaCharError: false,
        errorAlpha: 'Use only letters, hyphens, and apostrophes in the name field. Other special characters, including accents, are not supported. (Por ahora, en el campo de nombre usa solo letras, guiones y apóstrofes. No se admiten otros caracteres especiales, incluidas las tildes, las eñes (ñ), etc.)',
        minimumCharError: false,
        errorMinimumLength: 'Maximum 50 characters allowed',
        duplicateErrorStatus: false,
        duplicateErrorMessage: 'It looks like we already have details for this contact. Try adding a different contact, instead!'
      },
      relation: {
        name: 'Relationship to Child',
        value: '',
        errorStatus: false,
        errorText: ''
      },
      phone: {
        name: 'Phone',
        value: '',
        errorStatus: false,
        requiredStatus: false,
        errorText: 'This field is required. (Es necesario llenar este espacio.)'
      },
      phoneType: {
        name: 'Phone Type',
        value: 'Select',
        errorStatus: false,
        requiredStatus: false,
        errorText: 'Phone Type is required',
        dropStatus: false
      },
      pickUpStartDate: {
        name: 'Effective From',
        value: '',
        errorStatus: false,
        errorText: '',
        pickUpStartDateErr: false,
        dateCalculationErr: false
      },
      pickUpEndDate: {
        name: 'To',
        value: '',
        errorStatus: false,
        errorText: '',
        pickUpEndDateErr: false,
        dateCalculationErr: false
      },
      status: {
        value: ''
      },
      guid: {
        value: ''
      }
    }
  ];

  public static readonly EditSiteDetails =
    {
      arrivalPlan: {
        name: 'Arrival Plan',
        value: '',
        dropStatus: false,
        errorStatus: false,
        errorText: ''
      },
      dismissalPlan: {
        name: 'Dismissal Plan',
        value: '',
        dropStatus: false,
        errorStatus: false,
        errorText: ''
      }
    };

  public static readonly DROPDOWN_CONFIG ={label: '', id: 0, value: '', required: false, disable: false, search : false, placeholder : 'Search', showSelectLabel: true, firstSelectLabel:'Select', dropdownList: []  as {id: number; value: string}[]};
}
